import React from 'react';

const TipCard = ({ icon: Icon, title, text, color = "blue" }) => {
  const colors = {
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    green: "bg-green-50 text-green-700 border-green-200",
    purple: "bg-purple-50 text-purple-700 border-purple-200",
    orange: "bg-orange-50 text-orange-700 border-orange-200",
    red: "bg-red-50 text-red-700 border-red-200",
  };

  return (
    <div className={`rounded-xl p-3 flex items-start gap-2 border ${colors[color]}`}>
      <Icon size={18} className={`text-${color}-600 mt-0.5 flex-shrink-0`} />
      <div>
        <p className="font-semibold text-sm">{title}</p>
        <p className="text-xs opacity-90">{text}</p>
      </div>
    </div>
  );
};

export default TipCard;